module.exports = vendor_ffc6cc49023bedb78d9a;